// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"BQeNzkI6 _2IVOPH9e","breadcrumbs":"_2FiXsD8_ _2c5MZOKC _3G-LZVZa","productsCard":"T-Rsym1V","paginationButton":"_1GNN9ypT"};